module.exports = __webpack_public_path__ + "img/tick_square.c0ebe507.svg";